export default __webpack_public_path__ + "media/images/logos/logo_light-8e91f9b826dcf4ce64d4ff6f34d2cb98.png";